module.exports = __webpack_public_path__ + "img/mango.6a4b47a0.jpg";